function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import { withHotKeys } from 'react-hotkeys';
import TextListItem from '../textListItem/TextListItem';
import Divider from '../divider/Divider';
import { TEXT_ITEMS_PROP_TYPE } from './constants';
import { TABBABLE_INDEX, UNTABBABLE_INDEX, MOVE_TO_NEXT, MOVE_TO_PREV, MOVE_TO_FIRST, MOVE_TO_LAST, ACTIVATE_ITEM } from '../hotKeys/constants';
import { focusNewPosition, isToggledHelper, filterNonEmptyItems } from '../hotKeys/util';
import { ACTION_KEY_MAP } from './hotKeys'; // polyfill for Element.closest

import '../utils/elementClosest';
var STATIC_FOCUS_POSITION_ON_HOVER = -2;

var TextList =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(TextList, _React$PureComponent);

  function TextList(props) {
    var _defineProperty2;

    var _this;

    _classCallCheck(this, TextList);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TextList).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "hotKeyHandlers", (_defineProperty2 = {}, _defineProperty(_defineProperty2, MOVE_TO_NEXT, function (e) {
      if (!_this._getIsToggled()) {
        e.stopPropagation();

        _this._changeFocusedTextListItem(e, MOVE_TO_NEXT);
      }
    }), _defineProperty(_defineProperty2, MOVE_TO_PREV, function (e) {
      if (_this.state.focusPosition === 0 && _this.props.preventFocusWrap) {
        _this.props.onParentFocus();
      } else if (!_this._getIsToggled()) {
        _this._changeFocusedTextListItem(e, MOVE_TO_PREV);
      }
    }), _defineProperty(_defineProperty2, MOVE_TO_FIRST, function (e) {
      return _this._changeFocusedTextListItem(e, MOVE_TO_FIRST);
    }), _defineProperty(_defineProperty2, MOVE_TO_LAST, function (e) {
      return _this._changeFocusedTextListItem(e, MOVE_TO_LAST);
    }), _defineProperty(_defineProperty2, ACTIVATE_ITEM, function (e) {
      e.stopPropagation();
      e.preventDefault();
      var selectedItemValue = _this._focusedItemElement.id;

      if (_this.props.onItemSelect) {
        _this.props.onItemSelect(selectedItemValue, _this.state.focusPosition);
      }
    }), _defineProperty2));

    _defineProperty(_assertThisInitialized(_this), "_handleItemTentativeSelectFocus", function (_ref) {
      var value = _ref.value,
          content = _ref.content,
          index = _ref.index;

      _this._handleItemTentativeSelect(value, content, index);
    });

    _defineProperty(_assertThisInitialized(_this), "_handleItemTentativeSelectHover", function (_ref2) {
      var value = _ref2.value,
          content = _ref2.content,
          index = _ref2.index;
      var staticFocusOnTentativeSelect = _this.props.staticFocusOnTentativeSelect;
      var focusPosition = index;

      if (focusPosition !== -1 && staticFocusOnTentativeSelect) {
        /* Setting focus position explicitly here to ensure that
        when hovering, initial items do not incorrectly hold
        default focused appearance */
        focusPosition = STATIC_FOCUS_POSITION_ON_HOVER;
      }

      _this._handleItemTentativeSelect(value, content, focusPosition);
    });

    _this.state = {
      focusPosition: props.defaultFocusPosition
    };
    return _this;
  }

  _createClass(TextList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _selectedItemElement = this._selectedItemElement;
      var _this$props = this.props,
          autoscrollToSelected = _this$props.autoscrollToSelected,
          scrollContainerSelector = _this$props.scrollContainerSelector;
      var shouldScroll = autoscrollToSelected && _selectedItemElement;

      if (shouldScroll) {
        this._scrollIntoView(_selectedItemElement, scrollContainerSelector);
      }

      if (this._focusedItemElement) {
        this._focusedItemElement.focus();
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref3) {
      var defaultFocusPosition = _ref3.defaultFocusPosition,
          preventFocusWrap = _ref3.preventFocusWrap,
          parentKeyboardAction = _ref3.parentKeyboardAction;
      var focusPosition = this.state.focusPosition;
      var isToggled = isToggledHelper(defaultFocusPosition, focusPosition, parentKeyboardAction);

      if (preventFocusWrap) {
        if (isToggled) {
          this.setState({
            focusPosition: defaultFocusPosition
          });
        }
      }
    }
  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate() {
      this._clearSelectedItemRef();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _selectedItemElement = this._selectedItemElement;
      var _this$props2 = this.props,
          autoscrollToSelected = _this$props2.autoscrollToSelected,
          scrollContainerSelector = _this$props2.scrollContainerSelector,
          selectedItem = _this$props2.selectedItem;
      var wasJustSelected = selectedItem && !prevProps.selectedItem;
      var shouldScroll = autoscrollToSelected && _selectedItemElement && wasJustSelected;

      if (shouldScroll) {
        this._scrollIntoView(_selectedItemElement, scrollContainerSelector);
      }

      if (this._focusedItemElement) {
        this._focusedItemElement.focus();
      }
    }
  }, {
    key: "_getIsToggled",
    value: function _getIsToggled() {
      var _this$props3 = this.props,
          defaultFocusPosition = _this$props3.defaultFocusPosition,
          parentKeyboardAction = _this$props3.parentKeyboardAction;
      var focusPosition = this.state.focusPosition;
      return isToggledHelper(defaultFocusPosition, focusPosition, parentKeyboardAction);
    }
  }, {
    key: "_changeFocusedTextListItem",
    value: function _changeFocusedTextListItem(e, direction) {
      var _this$props4 = this.props,
          items = _this$props4.items,
          preventFocusWrap = _this$props4.preventFocusWrap;
      var focusPosition = this.state.focusPosition;
      var nonEmptyItems = filterNonEmptyItems(items);
      var boundFocusNewPosition = focusNewPosition.bind(null, nonEmptyItems, focusPosition, e, preventFocusWrap);
      this.setState(boundFocusNewPosition(direction));
    }
  }, {
    key: "_scrollIntoView",
    value: function _scrollIntoView(element, scrollContainerSelector) {
      if (element) {
        var scrollContainer = element.closest(scrollContainerSelector);

        if (scrollContainer) {
          scrollContainer.scrollTop = element.offsetTop;
        }
      }
    }
  }, {
    key: "_handleClick",
    value: function _handleClick(value, index) {
      var onItemSelect = this.props.onItemSelect;

      if (onItemSelect) {
        onItemSelect(value, index);
      }
    }
  }, {
    key: "_handleItemContentFocus",
    value: function _handleItemContentFocus(value, content, index) {
      this._handleItemTentativeSelect(value, content, index);
    }
  }, {
    key: "_clearSelectedItemRef",
    value: function _clearSelectedItemRef() {
      this._selectedItemElement = null;
    }
  }, {
    key: "_setListItemRef",
    value: function _setListItemRef(isSelected, isTentativelySelected, element) {
      if (isSelected) {
        this._selectedItemElement = element;
      }

      if (isTentativelySelected) {
        this._focusedItemElement = element;
      }
    } // NOTE: Merging keyboard event with mouse events so that in the case of a mouseOver,
    // the focusPosition is changed from the one determined from keyboard navigation
    // to the one determined by the mouseOver. This removes multiple highlights within
    // the same list.

  }, {
    key: "_handleItemTentativeSelect",
    value: function _handleItemTentativeSelect(value, content, focusPosition) {
      var onItemTentativeSelect = this.props.onItemTentativeSelect;

      if (value && focusPosition !== -1 && onItemTentativeSelect) {
        onItemTentativeSelect(value, content);
      }

      this.setState({
        focusPosition: focusPosition
      });
    }
  }, {
    key: "_getListItems",
    value: function _getListItems() {
      var _this2 = this;

      var _this$props5 = this.props,
          items = _this$props5.items,
          selectedItem = _this$props5.selectedItem,
          shouldFocusFirstItem = _this$props5.shouldFocusFirstItem,
          defaultFocusPosition = _this$props5.defaultFocusPosition;
      var focusPosition = this.state.focusPosition; // eslint-disable-next-line complexity

      return items.map(function (_ref4, index) {
        var path = _ref4.path,
            value = _ref4.value,
            content = _ref4.content,
            renderContainer = _ref4.renderContainer,
            iconType = _ref4.iconType,
            iconTypes = _ref4.iconTypes,
            iconSize = _ref4.iconSize,
            imageAlt = _ref4.imageAlt,
            imageUrl = _ref4.imageUrl,
            iconColor = _ref4.iconColor,
            buttonType = _ref4.buttonType,
            isSquareImage = _ref4.isSquareImage,
            tertiaryContent = _ref4.tertiaryContent,
            secondaryContent = _ref4.secondaryContent,
            header = _ref4.header,
            _ref4$dividerVertSpac = _ref4.dividerVertSpacing,
            dividerVertSpacing = _ref4$dividerVertSpac === void 0 ? 0 : _ref4$dividerVertSpac,
            _ref4$showDivider = _ref4.showDivider,
            showDivider = _ref4$showDivider === void 0 ? true : _ref4$showDivider;
        var isSelected = value === selectedItem;

        var onSelect = _this2._handleClick.bind(_this2, value, index);

        var onItemContentFocus = _this2._handleItemContentFocus.bind(_this2, value, content, index);

        var tentativeSelectHandlers = {};
        var isTentativelySelected;
        var isFocusable;
        var tabIndex;
        var isLastItem = index + 1 === items.length;
        var showingAsset = iconType || iconTypes || imageUrl;
        var divider = null;

        if (showDivider && showingAsset && !isLastItem) {
          divider = React.createElement("div", {
            className: "eds-l-pad-vert-".concat(dividerVertSpacing)
          }, React.createElement(Divider, null));
        }

        var headerComponent = null;

        if (header) {
          headerComponent = React.createElement("h3", {
            className: "eds-l-pad-hor-6 eds-text-color--grey-800 eds-l-pad-vert-1 eds-text-bl eds-text-weight--heavy",
            "data-spec": "eds-text-list-item-header"
          }, header);
        }

        isTentativelySelected = index === focusPosition;
        var tentativeSelectedData = {
          value: value,
          content: content,
          index: index
        };
        var clearTentativeSelectedData = {
          value: null,
          content: null,
          index: -1
        }; // we only want to have focus-management related props when there is a parent container
        // that passes in defaultFocusPosition to TextList

        if (defaultFocusPosition !== undefined) {
          isFocusable = false;
          tabIndex = isTentativelySelected ? TABBABLE_INDEX : UNTABBABLE_INDEX;
          tentativeSelectHandlers = {
            onMouseOver: function onMouseOver() {
              return _this2._handleItemTentativeSelectHover(tentativeSelectedData);
            },
            onMouseOut: function onMouseOut() {
              return _this2._handleItemTentativeSelectHover(clearTentativeSelectedData);
            },
            onFocus: function onFocus() {
              return _this2._handleItemTentativeSelectFocus(tentativeSelectedData);
            },
            onBlur: function onBlur() {
              return _this2._handleItemTentativeSelectFocus(clearTentativeSelectedData);
            }
          };
        } else {
          tentativeSelectHandlers = {
            onBlur: function onBlur() {
              return _this2._handleItemTentativeSelectFocus(clearTentativeSelectedData);
            }
          };
        }

        var storeRef = _this2._setListItemRef.bind(_this2, isSelected, isTentativelySelected); // If shouldFocusFirstItem, highlights the first option when the
        // user is in parent container (i.e. TextInput of AutocompleteField)


        if (shouldFocusFirstItem && focusPosition === -1 && index === 0) {
          isTentativelySelected = true;
        } // **should** be ok to disable since we're using hotkeys to provide a11y support
        // (and we have tests for it)

        /* eslint-disable jsx-a11y/click-events-have-key-events */


        return React.createElement("li", _extends({
          ref: storeRef,
          className: "eds-text-list__item",
          key: value,
          id: value,
          tabIndex: tabIndex,
          role: "menuitem",
          onClick: onSelect,
          "data-spec": "eds-text-list-item"
        }, tentativeSelectHandlers), headerComponent, React.createElement(TextListItem, {
          buttonType: buttonType,
          render: renderContainer,
          content: content || value,
          iconColor: iconColor,
          iconType: iconType,
          iconTypes: iconTypes,
          iconSize: iconSize,
          imageAlt: imageAlt,
          imageUrl: imageUrl,
          isSelected: isSelected,
          isSquareImage: isSquareImage,
          isTentativelySelected: isTentativelySelected,
          isFocusable: isFocusable,
          onSelect: onSelect,
          onItemContentFocus: onItemContentFocus,
          path: path,
          secondaryContent: secondaryContent,
          tertiaryContent: tertiaryContent
        }), divider);
        /* eslint-enable jsx-a11y/click-events-have-key-events */
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          id = _this$props6.id,
          innerRef = _this$props6.innerRef;
      return React.createElement("ul", {
        id: id,
        "data-spec": "text-list",
        className: "eds-text-list",
        role: "menu",
        ref: innerRef
      }, this._getListItems());
    }
  }]);

  return TextList;
}(React.PureComponent);

_defineProperty(TextList, "propTypes", {
  id: PropTypes.string,

  /**
   * Array of list item data.
   */
  items: TEXT_ITEMS_PROP_TYPE.isRequired,

  /**
   * The `value` in `items` that should be marked "selected"
   */
  selectedItem: PropTypes.string,

  /**
   * Callback function that will be called when a list item is selected
   */
  onItemSelect: PropTypes.func,

  /**
   * Callback function that will be called when a list item is tentatively selected
   */
  onItemTentativeSelect: PropTypes.func,

  /**
   * Should this list try to scroll to the selected item?
   */
  autoscrollToSelected: PropTypes.bool,

  /**
   * A valid CSS selector of the parent scroll container
   * This is required if autoscrollToSelected prop is true
   */
  scrollContainerSelector: PropTypes.string,

  /**
   * Default position (zero-based) within item list - received from DropdownMenu/AutocompleteField
   */
  defaultFocusPosition: PropTypes.number,

  /**
   * Whether the navigation for items should be un-wrapped (i.e. no first to last, last to first)
   */
  preventFocusWrap: PropTypes.bool,

  /**
   * Callback function that will be called when TextList's parent container should receive focus
   */
  onParentFocus: PropTypes.func,

  /**
   * Whether or not to set focus to the first text list item
   */
  shouldFocusFirstItem: PropTypes.bool,

  /**
   * A keyboard action coming from the parent component to help dictate which item in the list
   * should be focused by default (if any)
   */
  parentKeyboardAction: PropTypes.string,

  /**
   * Whether or not to update text list focusPosition state on
   * item hover tentative select.
   */
  staticFocusOnTentativeSelect: PropTypes.bool,

  /**
   * Ref function for interacting with the unordered list element from outside of the component.
   */
  // eslint-disable-next-line no-undef
  innerRef: PropTypes.func
});

_defineProperty(TextList, "defaultProps", {
  autoscrollToSelected: false,
  preventFocusWrap: false,
  shouldFocusFirstItem: false
});

export default withHotKeys(ACTION_KEY_MAP)(TextList);